<input class="form-control"
    placeholder="Pick a date"
    fullWidth
    [nbDatepicker]="formcontrol"
    [formControl]="inputControl"
    >
<nb-datepicker #formcontrol [format]="dateFormat"></nb-datepicker>
